import { ArrowRight } from "lucide-react";
import { CELEBRATE } from "./data";
import { Reveal } from "./Reveal";
import { useContent } from "./ContentContext";
import { useTx, txtStyle } from "./siteText";

export const Celebrate = () => {
  const { settings, resolveImg } = useContent();
  const tx = useTx();
  const cards = settings.celebrate && settings.celebrate.length ? settings.celebrate : CELEBRATE;
  return (
    <section id="celebrate" className="relative py-24 md:py-32 bg-cantina-navy text-cantina-cream overflow-hidden" data-testid="celebrate-section">
      <div className="absolute inset-0 tile-watermark opacity-[0.06]" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal className="text-center flex flex-col items-center mb-16">
          <p className="font-script text-cantina-marigold mb-2" style={txtStyle(tx("celebrate.eyebrow"))}>{tx("celebrate.eyebrow").text}</p>
          <h2 className="font-display tracking-tight" style={txtStyle(tx("celebrate.heading"))}>{tx("celebrate.heading").text}</h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {cards.map((c, i) => (
            <Reveal key={i} delay={i * 0.12}>
              <article className="group relative h-[440px] rounded-3xl overflow-hidden border border-white/10" data-testid={`celebrate-card-${i}`}>
                <img src={resolveImg(c.img)} alt={c.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1100ms] group-hover:scale-105" style={{ willChange: "transform" }} />
                <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(7,24,71,0.15) 0%, rgba(7,24,71,0.55) 55%, rgba(7,24,71,0.92) 100%)" }} />
                <div className="absolute inset-0 p-7 flex flex-col justify-end">
                  <span className="font-sans tracking-[0.25em] uppercase mb-2" style={{ color: c.color === "#0047AB" ? "#8FB8FF" : c.color, ...txtStyle(tx("celebrate.cardTag")) }}>{c.tag}</span>
                  <h3 className="font-display mb-2" style={txtStyle(tx("celebrate.cardTitle"))}>{c.title}</h3>
                  <p className="font-sans text-cantina-cream/75 leading-relaxed mb-5" style={txtStyle(tx("celebrate.cardDesc"))}>{c.desc}</p>
                  <a href={c.cta.href} target={c.cta.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 font-sans text-cantina-marigold group/link" style={txtStyle(tx("celebrate.cardCta"))} data-testid={`celebrate-cta-${i}`}>
                    {c.cta.label}
                    <ArrowRight size={16} className="transition-transform duration-300 group-hover/link:translate-x-1" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
